app.directive('smallButtonNoDesc', ['portalHelper', function (portalHelper) {
  return {
    scope: {
      title: '@',
      url: '@'
    },
    templateUrl: portalHelper.getUrlRev('html_templates/directives/small_button_no_desc.e590a621.html'),
    controller: function ($scope, $sce) {
      $scope.$watch('title', function (value) {
        $scope.titleAsHtml = $sce.trustAsHtml(value);
      });
      $scope.goToDataUrl = function (url) {
        location.href = url;
      };
    }
  };
}]);
